import React, { useEffect } from "react";
import "../../assets/styles/VisitorStatisticsStyle/SalesReportStyle/SalesReportDeliveryType.css";
import { convertObjToArray } from "../../helper/Helper";
import axios from "../../js/Axios/Axios";
import {
  VictoryPie,
  VictoryTheme,
  VictoryLabel,
  VictoryTooltip,
} from "victory";
import { useState } from "react";
import useForceUpdate from "use-force-update";
export default function VisitorStatisticsSites() {
  const forceUpdate = useForceUpdate();
  const [data, setData] = useState([]);
  const [dataChart, setDataChart] = useState([]);
  const [witchData, setWitchData] = useState(null);
  useEffect(() => {
    axios
      .get("/StoreDeliveryType/report?")
      .then((res) => {
        console.log("yesss", res);
        let array = convertObjToArray(res.data);
        setData(convertObjToArray(res.data));
        dataChart.map((item , index) => {
          dataChart.splice(index)
        })
        array.map((item) => {
          dataChart.push({
            x: item.key,
            y: item.value.order_count_percentage,
          });
        });
        forceUpdate()
      })

      .catch((e) => {
        console.log(e);
      });
  }, []);
  console.log(data);

  return (
    <div className="sales-report-sites">
      <div className="sales-report-sites-details">
        {data.map((item, index) => {
          return (
            <div key={index} className="sales-report-sites-details-2">
              <p>{item.key}</p>
              <div className="sales-report-sites-count">
                {item.key === "وانت" && (
                  <div className="sales-report-sites-count-color"></div>
                )}
                {item.key === "پیک موتور" && (
                  <div className="sales-report-sites-count-color-2"></div>
                )}
                {item.key === "کامیون" && (
                  <div className="sales-report-sites-count-color-3"></div>
                )}
                {item.key === "کامیونت" && (
                  <div className="sales-report-sites-count-color-4"></div>
                )}
                <p>{item.value.order_count} مرسوله</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="sales-report-sites-pie-chart">
        {data.length != 0 && (
          <VictoryPie
            padAngle={0}
            labels={(props) => props.datum.y === 0 ? "" : [`% ${props.datum.y}`]}
            style={{
              labels: {
                fill: "#fff",
                fontSize: 12,
                fontWeight: "500",
                fontFamily: "IRANSansFaNum",
              },
            }}
            labelComponent={<VictoryLabel dy={-0} textAnchor="middle" />}
            innerRadius={90}
            width={200}
            height={200}
            data={dataChart}
            colorScale={["#ffe700", "#826af9", "#f7d2ff", "#2d99ff"]}
            events={[
              {
                target: "data",
                eventHandlers: {
                  onMouseOver: () => {
                    return [
                      {
                        mutation: (props) => {
                          console.log(props);
                          setWitchData(data[props.index]);
                        },
                      },
                    ];
                  },
                  onMouseOut: () => {
                    return [
                      {
                        mutation: () => {
                          setWitchData(null);
                        },
                      },
                    ];
                  },
                },
              },
            ]}
          />
        )}
        {witchData !== null && (
          <div className="sales-report-sites-pie-chart-label">
            <p>{witchData.key}</p>
            <p>{witchData.value.order_count_percentage}%</p>
          </div>
        )}
      </div>
    </div>
  );
}
